import { useContext } from 'react'

import { DownloadContext } from './DownloadContext'

export function useDownload() {
    const download = useContext(DownloadContext)
    if (!download) throw new Error('useDownload requires DownloadProvider')

    return download
}
